import { Box, Chip } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { type SaleDocumentSummary } from "../types";
import { attributeChipSx } from "../utils/saleTokens";

interface Props {
  buildingType: SaleDocumentSummary["buildingType"];
}

/**
 * 建物の種類（分譲マンション / 一棟建物 / 戸建 / その他。更地や種類を判定できない物件は「その他」）の Chip。登記と突き合わせて物件を見分けるために、見出しの隣に置く。
 * 種類で色を変えない（白地と枠）。値が無ければ何も出さない。読み上げは「建物の種類: 分譲マンション」。
 */
export const SaleBuildingTypeChip: React.FC<Props> = ({ buildingType }) => {
  const value = buildingType.trim();
  if (value === "") return null;
  return (
    <Chip
      component="span"
      size="small"
      data-testid="sale-building-type-chip"
      label={
        <>
          <Box component="span" sx={visuallyHidden}>
            建物の種類:{" "}
          </Box>
          {value}
        </>
      }
      sx={(theme) => ({ ...attributeChipSx(theme), whiteSpace: "nowrap" })}
    />
  );
};
